<ng-template #template>
  <div class="pb-5" class="col-lg-12">
    <div class="card" style="background-color: #0e0e29; line-height: 1.5">
      <div class="card-body">
        <h3 style="color: white">{{ source?.title }}</h3>
        <div class="progress" style="height: 20px">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width]="getvalue1()"
            [style.background-color]="rgbColor"
            aria-valuenow=""
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <span>{{ source?.bar1Title }}</span>
          </div>
        </div>
        <div style="text-align: right">{{ value1Text }}</div>
        <br />
        <div class="progress" style="height: 20px">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width]="getvalue2()"
            style="width: 35%"
            [style.background-color]="rgbColor"
            aria-valuenow=""
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <span>{{ source?.bar2Title }}</span>
          </div>
        </div>
        <div style="text-align: right">{{ value2Text }}</div>
      </div>
    </div>
  </div>
</ng-template>
